// import React, { useState, useEffect, useCallback } from "react";
// import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// import { Link, useLocation } from "react-router-dom";

// export default function Navbar() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: "Home", path: "/home" },
//     { name: "About-Us", path: "/about" },
//     { name: "Services", path: "/services" },
//     { name: "Technology", path: "/technology" },
//     { name: "Contact-Us", path: "/contact" },
//   ];

//   const serviceLinks = [
//     { name: "Web Development", path: "/web" },
//     { name: "Mobile App Development", path: "/mob" },
//     { name: "E-Commerce Solutions", path: "/ecom" },
//     { name: "Salesforce", path: "/salesforce" },
//     { name: "ServiceNow", path: "/contact" },
//     { name: "Staff Augmentation", path: "/staff" },
//   ];

//   const handleHover = useCallback((state) => {
//     setDropdownOpen(state);
//   }, []);

//   // Scroll detector
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 20);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <header
//       className={`fixed top-0 w-full z-50 transition-all duration-500
//       ${
//         scrolled
//           ? "bg-black/80 shadow-[0_4px_20px_rgba(0,0,0,0.5)] backdrop-blur-xl"
//           : "bg-transparent !bg-opacity-0 !backdrop-blur-none shadow-none"
//       }
//       `}
//       style={{ padding: "10px 0" }}
//     >
//       <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">

//         {/* LOGO */}
//         <Link to="/" className="flex items-center gap-2 group">
//           <img
//             src="/logo.png"
//             alt="Codex Logo"
//             className="w-9 h-9 sm:w-10 sm:h-10 transition-transform duration-300 group-hover:scale-105"
//             loading="lazy"
//           />
//           <span className="text-lg sm:text-xl md:text-2xl font-extrabold whitespace-nowrap text-white">
//             Codex Future Technologies
//           </span>
//         </Link>

//         {/* DESKTOP NAV */}
//         <nav className="hidden md:flex gap-6 lg:gap-8 items-center relative">
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div
//                 key={link.name}
//                 className="relative"
//                 onMouseEnter={() => handleHover(true)}
//                 onMouseLeave={() => handleHover(false)}
//               >
//                 <button
//                   className={`flex items-center gap-1 font-semibold transition-all duration-300
//                     ${
//                       location.pathname === "/services"
//                         ? "text-[#df2313]"
//                         : "text-white hover:text-[#df2313]"
//                     }`}
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`mt-[1px] transition-transform duration-300 ${
//                       dropdownOpen ? "rotate-180 text-[#df2313]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 {/* Desktop dropdown */}
//                 <div
//                   className={`absolute left-0 mt-2 w-56 bg-black border border-gray-700 rounded-xl shadow-xl py-2 z-50 transition-all duration-300
//                     ${
//                       dropdownOpen
//                         ? "opacity-100 translate-y-0 visible"
//                         : "opacity-0 translate-y-2 invisible"
//                     }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       className="block px-4 py-2 text-white hover:bg-[#df2313] transition-all duration-200 rounded-md"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className={`font-semibold transition-all duration-300
//                 ${
//                   location.pathname === link.path
//                     ? "text-[#df2313]"
//                     : "text-white hover:text-[#df2313]"
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}
//         </nav>

//         {/* MOBILE BUTTON */}
//         <button
//           onClick={() => setMenuOpen(!menuOpen)}
//           className="md:hidden text-white transition-transform active:scale-90"
//           aria-label="Toggle Menu"
//         >
//           {menuOpen ? <FiX size={26} /> : <FiMenu size={26} />}
//         </button>
//       </div>

//       {/* ================= MOBILE MENU ================= */}
//       <div
//         className={`md:hidden absolute top-full left-0 w-full bg-black/95 backdrop-blur-xl transition-all duration-300
//           ${
//             menuOpen
//               ? "translate-y-0 opacity-100 visible"
//               : "-translate-y-5 opacity-0 invisible"
//           }`}
//       >
//         <div className="flex flex-col items-center py-4 gap-3">

//           {/* MOBiLE LINKS */}
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div key={link.name} className="w-full text-center">

//                 {/* MAIN BUTTON */}
//                 <button
//                   onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
//                   className="flex items-center justify-center w-full gap-2 text-white text-lg font-semibold hover:text-[#df2313] py-2"
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform duration-300 ${
//                       mobileDropdownOpen ? "rotate-180" : ""
//                     }`}
//                   />
//                 </button>

//                 {/* MOBILE DROPDOWN */}
//                 <div
//                   className={`flex flex-col items-center w-full transition-all duration-300 overflow-hidden
//                     ${
//                       mobileDropdownOpen
//                         ? "max-h-96 opacity-100"
//                         : "max-h-0 opacity-0"
//                     }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       onClick={() => setMenuOpen(false)}
//                       className="w-full text-center py-2 text-white hover:text-[#df2313] transition-all"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 onClick={() => setMenuOpen(false)}
//                 className={`w-full text-center text-lg font-semibold py-2 transition-all duration-300
//                 ${
//                   location.pathname === link.path
//                     ? "text-[#df2313]"
//                     : "text-white hover:text-[#df2313]"
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }



// import React, { useState, useEffect, useCallback } from "react";
// import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// import { Link, useLocation } from "react-router-dom";

// export default function Navbar({ handleToggle }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: "Home", path: "/home" },
//     { name: "About-Us", path: "/about" },
//     { name: "Services", path: "/services" },
//     { name: "Technology", path: "/technology" },
//     { name: "Contact-Us", path: "/contact" },
//   ];

//   const serviceLinks = [
//     { name: "Web Development", path: "/web" },
//     { name: "Mobile App Development", path: "/mob" },
//     { name: "E-Commerce Solutions", path: "/ecom" },
//     { name: "Salesforce", path: "/salesforce" },
//     { name: "ServiceNow", path: "/contact" },
//     { name: "Staff Augmentation", path: "/staff" },
//   ];

//   const handleHover = useCallback((state) => {
//     setDropdownOpen(state);
//   }, []);

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 20);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <header
//       className="fixed top-0 w-full z-50 transition-all duration-500 bg-black" 
//     >
//       <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8 lg:px-10">

//         {/* LOGO */}
//         <Link to="/" className="flex items-center gap-2 group">
//           <img
//             src="/logo.png"
//             alt="Codex Logo"
//             className="w-10 h-10 transition-transform duration-300 group-hover:scale-105"
//           />
//           <span className="text-xl md:text-2xl font-extrabold text-white">
//             Codex Future Technologies
//           </span>
//         </Link>

//         {/* DESKTOP MENU */}
//         <nav className="hidden md:flex gap-7 items-center relative">
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div
//                 key={link.name}
//                 className="relative"
//                 onMouseEnter={() => handleHover(true)}
//                 onMouseLeave={() => handleHover(false)}
//               >
//                 <button
//                   className={`flex items-center gap-1 font-semibold ${
//                     location.pathname === "/services"
//                       ? "text-[#df2313]"
//                       : "text-white hover:text-[#df2313]"
//                   }`}
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform duration-300 ${
//                       dropdownOpen ? "rotate-180 text-[#df2313]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 {/* DROPDOWN */}
//                 <div
//                   className={`absolute left-0 mt-2 w-56 bg-black border border-gray-700 rounded-xl shadow-xl py-2 transition-all duration-300 ${
//                     dropdownOpen
//                       ? "opacity-100 translate-y-0 visible"
//                       : "opacity-0 translate-y-2 invisible"
//                   }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       className="block px-4 py-2 text-white hover:bg-[#df2313] transition-all"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className={`font-semibold ${
//                   location.pathname === link.path
//                     ? "text-[#df2313]"
//                     : "text-white hover:text-[#df2313]"
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}

//           {/* 🔥 THEME TOGGLE BUTTON */}
//           <button
//             onClick={handleToggle}
//             className="ml-4 border border-[#df2313] text-[#df2313] px-3 py-1 rounded-lg hover:bg-[#df2313] hover:text-white transition-all"
//           >
//             Switch
//           </button>
//         </nav>

//         {/* MOBILE MENU BUTTON */}
//         <button
//           onClick={() => setMenuOpen(!menuOpen)}
//           className="md:hidden text-white transition-transform"
//         >
//           {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
//         </button>

//         {/* 🔥 MOBILE TOGGLE BUTTON */}
//         <button
//           onClick={handleToggle}
//           className="md:hidden ml-3 border border-[#df2313] text-[#df2313] px-3 py-1 rounded-lg"
//         >
//           Switch
//         </button>
//       </div>
//     </header>
//   );
// }



// import React, { useState, useEffect, useCallback } from "react";
// import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
// import { Link, useLocation } from "react-router-dom";

// export default function Navbar({ handleToggle }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: "Home", path: "/home" },
//     { name: "About-Us", path: "/about" },
//     { name: "Services", path: "/services" },
//     { name: "Technology", path: "/technology" },
//     { name: "Contact-Us", path: "/contact" },
//   ];

//   const serviceLinks = [
//     { name: "Web Development", path: "/web" },
//     { name: "Mobile App Development", path: "/mob" },
//     { name: "E-Commerce Solutions", path: "/ecom" },
//     { name: "Salesforce", path: "/salesforce" },
//     { name: "ServiceNow", path: "/contact" },
//     { name: "Staff Augmentation", path: "/staff" },
//   ];

//   const handleHover = useCallback((state) => {
//     setDropdownOpen(state);
//   }, []);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <header
//       className={`fixed top-0 w-full z-50 transition-all duration-500
//       ${scrolled ? "bg-black/90 backdrop-blur-md" : "bg-black"}`}
//     >
//       <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8">

//         {/* LOGO */}
//         <Link to="/" className="flex items-center gap-2 group">
//           <img
//             src="/logo.png"
//             alt="Codex Logo"
//             className="w-10 h-10 transition-transform duration-300 group-hover:scale-110"
//           />
//           <span className="text-lg sm:text-xl md:text-2xl font-extrabold text-white whitespace-nowrap">
//             Codex Future Technologies
//           </span>
//         </Link>

//         {/* DESKTOP MENU */}
//         <nav className="hidden md:flex gap-7 items-center relative">
//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div
//                 key={link.name}
//                 className="relative"
//                 onMouseEnter={() => handleHover(true)}
//                 onMouseLeave={() => handleHover(false)}
//               >
//                 <button
//                   className={`flex items-center gap-1 font-semibold transition-all duration-300 ${
//                     location.pathname === "/services"
//                       ? "text-[#df2313]"
//                       : "text-white hover:text-[#df2313]"
//                   }`}
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform duration-300 ${
//                       dropdownOpen ? "rotate-180 text-[#df2313]" : "text-white"
//                     }`}
//                   />
//                 </button>

//                 {/* Desktop Dropdown */}
//                 <div
//                   className={`absolute left-0 mt-2 w-56 bg-black border border-gray-700 rounded-xl shadow-xl py-2 transition-all duration-300 z-50 ${
//                     dropdownOpen
//                       ? "opacity-100 translate-y-0 visible"
//                       : "opacity-0 translate-y-2 invisible"
//                   }`}
//                 >
//                   {serviceLinks.map((service) => (
//                     <Link
//                       key={service.name}
//                       to={service.path}
//                       className="block px-4 py-2 text-white hover:bg-[#df2313] transition-all rounded-md"
//                     >
//                       {service.name}
//                     </Link>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className={`font-semibold transition-all duration-300 ${
//                   location.pathname === link.path
//                     ? "text-[#df2313]"
//                     : "text-white hover:text-[#df2313]"
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}

//           {/* Theme Toggle */}
//           <button
//             onClick={handleToggle}
//             className="ml-4 border border-[#df2313] text-[#df2313] px-3 py-1 rounded-lg hover:bg-[#df2313] hover:text-white transition-all"
//           >
//             Switch
//           </button>
//         </nav>

//         {/* MOBILE MENU BUTTON */}
//         <div className="md:hidden flex items-center gap-2">
//           <button
//             onClick={() => setMenuOpen(!menuOpen)}
//             className="text-white"
//           >
//             {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
//           </button>

//           {/* MOBILE SWITCH */}
//           <button
//             onClick={handleToggle}
//             className="border border-[#df2313] text-[#df2313] px-2 py-2 rounded-lg"
//           >
//             Switch
//           </button>
//         </div>
//       </div>

//       {/* MOBILE MENU */}
//       {menuOpen && (
//         <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-gray-700 px-6 py-4 space-y-4">

//           {navLinks.map((link) =>
//             link.name === "Services" ? (
//               <div key={link.name} className="text-white">
//                 {/* Services Button */}
//                 <button
//                   onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
//                   className="w-full flex justify-between items-center font-semibold text-left text-white py-2"
//                 >
//                   {link.name}
//                   <FiChevronDown
//                     className={`transition-transform ${
//                       mobileDropdownOpen ? "rotate-180 text-[#df2313]" : ""
//                     }`}
//                   />
//                 </button>

//                 {/* Mobile Services Dropdown */}
//                 {mobileDropdownOpen && (
//                   <div className="pl-4 space-y-2">
//                     {serviceLinks.map((service) => (
//                       <Link
//                         key={service.name}
//                         to={service.path}
//                         className="block text-gray-300 hover:text-[#df2313] transition"
//                         onClick={() => setMenuOpen(false)}
//                       >
//                         {service.name}
//                       </Link>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <Link
//                 key={link.name}
//                 to={link.path}
//                 className="block text-white font-semibold py-2"
//                 onClick={() => setMenuOpen(false)}
//               >
//                 {link.name}
//               </Link>
//             )
//           )}
//         </div>
//       )}
//     </header>
//   );
// }



import React, { useState, useEffect, useCallback } from "react";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

export default function Navbar({ handleToggle }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/home" },
    { name: "About-Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Technology", path: "/technology" },
    { name: "Contact-Us", path: "/contact" },
  ];

  const serviceLinks = [
    { name: "Web Development", path: "/web" },
    { name: "Mobile App Development", path: "/mob" },
    { name: "E-Commerce Solutions", path: "/ecom" },
    { name: "Salesforce", path: "/salesforce" },
    { name: "ServiceNow", path: "/contact" },
    { name: "Staff Augmentation", path: "/staff" },
  ];

  const handleHover = useCallback((state) => {
    setDropdownOpen(state);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-500
      ${scrolled ? "bg-black/90 backdrop-blur-md" : "bg-black"}`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center py-3 px-4 sm:px-6 md:px-8">

        {/* LOGO */}
        <Link to="/" className="flex items-center gap-2 group">
          <img
            src="/logo.png"
            alt="Codex Logo"
            className="w-10 h-10 transition-transform duration-300 group-hover:scale-110"
          />
          <span className="text-lg sm:text-xl md:text-2xl font-extrabold text-white whitespace-nowrap">
            Codex Future Technologies
          </span>
        </Link>

        {/* DESKTOP MENU */}
        <nav className="hidden md:flex gap-7 items-center relative">
          {navLinks.map((link) =>
            link.name === "Services" ? (
              <div
                key={link.name}
                className="relative"
                onMouseEnter={() => handleHover(true)}
                onMouseLeave={() => handleHover(false)}
              >
                <button
                  className={`flex items-center gap-1 font-semibold transition-all duration-300 ${
                    location.pathname === "/services"
                      ? "text-[#df2313]"
                      : "text-white hover:text-[#df2313]"
                  }`}
                >
                  {link.name}
                  <FiChevronDown
                    className={`transition-transform duration-300 ${
                      dropdownOpen ? "rotate-180 text-[#df2313]" : "text-white"
                    }`}
                  />
                </button>

                {/* Desktop Dropdown */}
                <div
                  className={`absolute left-0 mt-2 w-56 bg-black border border-gray-700 rounded-xl shadow-xl py-2 transition-all duration-300 z-50 ${
                    dropdownOpen
                      ? "opacity-100 translate-y-0 visible"
                      : "opacity-0 translate-y-2 invisible"
                  }`}
                >
                  {serviceLinks.map((service) => (
                    <Link
                      key={service.name}
                      to={service.path}
                      className="block px-4 py-2 text-white hover:bg-[#df2313] transition-all rounded-md"
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                key={link.name}
                to={link.path}
                className={`font-semibold transition-all duration-300 ${
                  location.pathname === link.path
                    ? "text-[#df2313]"
                    : "text-white hover:text-[#df2313]"
                }`}
              >
                {link.name}
              </Link>
            )
          )}

          {/* Theme Toggle */}
          <button
            onClick={handleToggle}
            className="ml-4 border border-[#df2313] text-[#df2313] px-3 py-1 rounded-lg hover:bg-[#df2313] hover:text-white transition-all"
          >
            Switch
          </button>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white"
        >
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-gray-700 px-6 py-4 space-y-4">

          {navLinks.map((link) =>
            link.name === "Services" ? (
              <div key={link.name} className="text-white">
                {/* Services Button */}
                <button
                  onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                  className="w-full flex justify-between items-center font-semibold text-left text-white py-2"
                >
                  {link.name}
                  <FiChevronDown
                    className={`transition-transform ${
                      mobileDropdownOpen ? "rotate-180 text-[#df2313]" : ""
                    }`}
                  />
                </button>

                {/* Mobile Services Dropdown */}
                {mobileDropdownOpen && (
                  <div className="pl-4 space-y-2">
                    {serviceLinks.map((service) => (
                      <Link
                        key={service.name}
                        to={service.path}
                        className="block text-gray-300 hover:text-[#df2313] transition"
                        onClick={() => setMenuOpen(false)}
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={link.name}
                to={link.path}
                className="block text-white font-semibold py-2"
                onClick={() => setMenuOpen(false)}
              >
                {link.name}
              </Link>
            )
          )}

          {/* ✅ MOBILE SWITCH BUTTON INSIDE MENU */}
          <button
            onClick={() => {
              handleToggle();
              setMenuOpen(false);
            }}
            className="w-full mt-2 border border-[#df2313] text-[#df2313] px-4 py-2 rounded-lg text-center font-semibold hover:bg-[#df2313] hover:text-white transition-all"
          >
            Switch Theme
          </button>
        </div>
      )}
    </header>
  );
}
